<template>
    <v-card flat>
                <v-card-text>
                    <v-simple-table
                        v-if="renderComponent"
                        fixed-header
                        height="400px"
                    >
                        
                        <template v-slot:top>
                            
                            <v-progress-linear
                                indeterminate
                                :color="loadingTable ? 'yellow darken-2' : ''"
                            />
                            
                        </template>

                        <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Dia/Horario</th>
                                <th class="text-left">Aceite</th>
                                <th class="text-center">Motivo</th>
                                <th class="text-left">Justificativa</th>
                                <th class="text-left">Observação Coordenador.</th>
                                <th class="text-left">Data</th>
                                <th class="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item2, i) in item.processItems"
                                :key="i"
                            >
                                <td class="text-no-wrap">
                                    {{ item2.description }}
                                </td>
                                <td>
                                    <span v-if="item2.attribution_process_status_id == 1">
                                        <v-icon color="primary">
                                        mdi-progress-clock
                                        </v-icon>
                                        <br/>
                                        <small>Pendente de Envio</small>
                                    </span>
                                    <span v-else-if="item2.attribution_process_status_id == 2">
                                        <v-icon color="primary">
                                            mdi-progress-clock
                                        </v-icon>
                                        <br/>
                                        <small>Pendende de Aceite</small>
                                    </span>
                                    <span v-else-if="item2.attribution_process_status_id == 3">
                                        <v-icon color="error">
                                            mdi-thumb-down-outline
                                        </v-icon> 
                                        <br/>
                                        <small>Recusada</small>
                                   </span>
                                    <span v-else-if="item2.attribution_process_status_id == 4">
                                        <v-icon color="primary">
                                            mdi-thumb-up-outline
                                        </v-icon>
                                        <br/>
                                        <small>Aceita</small>
                                    </span>
                                    <span v-else-if="item2.attribution_process_status_id == 5">
                                        <v-icon color="primary">
                                            mdi-timer-off-outline
                                        </v-icon>
                                        <br/>
                                        <small>Expirada</small>
                                    </span>
                                  
                                   
                                </td>
                                <td>{{ item2.reaser }}</td>
                                <td>{{ item2.justification }}</td>
                                <td>{{ item2.note_user }}</td>
                                <td>{{ item2.created_at | dateTime }}</td>
                                <td>
                                    
                                </td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
        </v-card>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name: 'SysTeacherAttributionAccept',
    data: function() {
        return {
            loading: false,
            loadingTable: false,
            loadingDelete: false,
            itemEdit: null,
            itemNew: null,
            itemDelete: null,
            showDelete: false,
            renderComponent: true,
            showForm: false,
            type: 'edit',
            showFormNewtItem: false,
            item: {},
        }
    },
    props: {
        model: {

        },
    },
    created() {
        this.loadData();
    },
    watch: {
        model(val){
            this.loadData();
        }
    },
    methods: {
        ...mapActions('attribution', ['ActionFindAttributionsById']),

        loadData(){

            if(!this.model || !this.model.id){
                return;
            }
            
            this.loadingTable = true;
            this.item = {};
            
            let payload = {
                id: this.model.id,
                with: 'processItems.status',
                column_order: 'updated_at',
                direction: 'desc'
            }
            
            this.ActionFindAttributionsById(payload)
                    .then((res) => {
                        this.item = res.data;
                    })
                    .catch((error) =>{
                       
                    })
                    .finally(() => {
                        this.loadingTable = false;
                    });
        },

        forceRerender () {
            
            this.renderComponent = false;

            this.$nextTick(() => {
                this.renderComponent = true;
            });

        },
        
    },
}
</script>